import React, { createContext, useContext, useEffect, useState } from 'react'
import { client } from '../lib/sanityClient'

const LISTING_QUERY = `*[_type == "blogPost" && active == true] | order(publishedAt desc) {
  _id,
  title,
  "slug": slug.current,
  excerpt,
  coverImage,
  category,
  author,
  authorRole,
  authorImage,
  publishedAt,
  estimatedReadingTime
}`

const BlogContext = createContext(null)

export function BlogProvider({ children }) {
  const [posts, setPosts] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false

    client
      .fetch(LISTING_QUERY)
      .then((data) => {
        if (!cancelled) {
          setPosts(data || [])
          setLoading(false)
        }
      })
      .catch((err) => {
        if (!cancelled) {
          console.error('Failed to fetch blog posts:', err)
          setError(err)
          setLoading(false)
        }
      })

    return () => {
      cancelled = true
    }
  }, [])

  const hasActivePosts = !loading && posts.length > 0

  return (
    <BlogContext.Provider value={{ posts, loading, error, hasActivePosts }}>
      {children}
    </BlogContext.Provider>
  )
}

export function useBlog() {
  const ctx = useContext(BlogContext)
  if (!ctx) throw new Error('useBlog must be used within a BlogProvider')
  return ctx
}
